import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { BaseInspectionService, InspectionModelService } from '../../services/index';
import { BaseModalPageComponent } from '../../../base-modal.component';

import * as _ from 'lodash';

@Component({
    templateUrl: './model-sections.component.html',
    standalone: false
})
export class BaseImportModelSectionsPageComponent extends BaseModalPageComponent implements OnInit {
  model: any;
  id: string;
  modelId: string;
  selectedSections: any;
  errorMessage: string;
  createProcessing = false;
  navigationRoute: string;

  public loading: Boolean = true;

  constructor(
    public baseInspectionService: BaseInspectionService,
    public inspectionModelService: InspectionModelService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    location: Location,
    public cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['targetId'];
      if (id == null) this.router.navigate([this.navigationRoute]);

      this.id = id;

      const modelId = params['modelId'];
      if (modelId == null) this.goToBack();

      this.modelId = modelId;

      this.initData();
    });
  }

  selectInspectionSection(inspectionSection: any): void {
    inspectionSection.selected = !inspectionSection.selected;
    this.selectedSections = _.filter(this.model.sections, (s: any) => s.selected).sort((el) => el.order);
    this.cdRef.detectChanges();
  }

  addSection(): void {
    this.createProcessing = true;
    let sectionsIds = _.map(this.selectedSections, (el: any) => el.id);
    this.baseInspectionService.addSection(this.id, this.modelId, sectionsIds).subscribe((data) => {
      this.resetSelectedSections();
      window.history.go(-2);
    });
  }

  cancel() {
    this.resetSelectedSections();
    this.goToBack();
  }

  initData(): void {
    this.inspectionModelService.getModel(this.modelId).subscribe((model) => {
      this.model = model;
      this.loading = false;
    });
  }

  resetSelectedSections() {
    if (this.selectedSections) {
      this.selectedSections.forEach((s) => (s.selected = false));
    }
  }
}
